import { InputAdornment, MenuItem, Stack, TextField, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import * as yup from 'yup';
import { departmentOptions } from '../../common/enums.tsx';
import { PatientCompleteWizardType } from '../ui/WizardStep.tsx';

const sexOptions = ['Femme', 'Homme', 'Non spécifié'];
const maritalStatusOptions = ['Célibataire', 'Marié', 'Divorcé', 'Veuf'];
const professionalStatusOptions = [
  'Agriculteurs',
  'Artisans, commerçants et chefs d’entreprise',
  'Cadres et professions intellectuelles supérieures',
  'Professions intermédiaires',
  'Employés',
  'Ouvriers',
  'Etudiant',
  'Sans emploi',
  'Autre',
];

const educationLevelOptions = [
  'CAP, BEP',
  'Baccalauréat',
  'DEUG, BTS, DUT, DEUST',
  'Licence, Licence LMD, licence professionnelle',
  'Maîtrise',
  "Master, DEA, DESS, diplôme d'ingénieur",
  'Doctorat, habilitation à diriger des recherches',
  'Autre',
];

const PatientCompleteWizardStep1: PatientCompleteWizardType = ({ formik }) => {
  return (
    <>
      <Grid container spacing={3}>
        <Grid size={1}> </Grid>
        <Grid size={3}>
          <Typography>Année de naissance & Sexe</Typography>
        </Grid>
        <Grid size={8}>
          <Stack direction="row" spacing={3}>
            <TextField
              error={formik.touched.yearOfBirth && Boolean(formik.errors.yearOfBirth)}
              fullWidth
              helperText={formik.touched.yearOfBirth && formik.errors.yearOfBirth}
              label="Année"
              name="yearOfBirth"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              placeholder="Entrer l'année"
              required
              type="number"
              value={formik.values.yearOfBirth}
            />
            <TextField
              error={formik.touched.sex && Boolean(formik.errors.sex)}
              fullWidth
              helperText={formik.touched.sex && formik.errors.sex}
              label="Sexe"
              name="sex"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              required
              select
              value={formik.values.sex}
            >
              {sexOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Stack>
        </Grid>
        <Grid size={1}> </Grid>
        <Grid size={3}>
          <Typography>Taille et poids</Typography>
        </Grid>
        <Grid size={8}>
          <Stack direction="row" spacing={3}>
            <TextField
              InputProps={{ endAdornment: <InputAdornment position="end">cm</InputAdornment> }}
              error={formik.touched.height && Boolean(formik.errors.height)}
              fullWidth
              helperText={formik.touched.height && formik.errors.height}
              label="Taille"
              name="height"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              placeholder="Entrer la taille"
              type="number"
              value={formik.values.height}
            />
            <TextField
              InputProps={{ endAdornment: <InputAdornment position="end">kg</InputAdornment> }}
              error={formik.touched.weight && Boolean(formik.errors.weight)}
              fullWidth
              helperText={formik.touched.weight && formik.errors.weight}
              inputProps={{ step: 1 }}
              label="Poids"
              name="weight"
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              placeholder="Entrer le poids"
              type="number"
              value={formik.values.weight}
            />
          </Stack>
        </Grid>
        <Grid size={1}> </Grid>
        <Grid size={3}>
          <Typography>Statut marital</Typography>
        </Grid>
        <Grid size={8}>
          <TextField
            error={formik.touched.maritalStatus && Boolean(formik.errors.maritalStatus)}
            fullWidth
            helperText={formik.touched.maritalStatus && formik.errors.maritalStatus}
            label="Statut marital"
            name="maritalStatus"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            required
            select
            value={formik.values.maritalStatus}
          >
            {maritalStatusOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={1}> </Grid>
        <Grid size={3}>
          <Typography>Statut professionnel</Typography>
        </Grid>
        <Grid size={8}>
          <TextField
            error={formik.touched.professionalStatus && Boolean(formik.errors.professionalStatus)}
            fullWidth
            helperText={formik.touched.professionalStatus && formik.errors.professionalStatus}
            label="Statut professionnel"
            name="professionalStatus"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            required
            select
            value={formik.values.professionalStatus}
          >
            {professionalStatusOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={1}> </Grid>
        <Grid size={3}>
          <Typography>Niveau d'éducation</Typography>
        </Grid>
        <Grid size={8}>
          <TextField
            error={formik.touched.educationLevel && Boolean(formik.errors.educationLevel)}
            fullWidth
            helperText={formik.touched.educationLevel && formik.errors.educationLevel}
            label="Niveau d'éducation"
            name="educationLevel"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            required
            select
            value={formik.values.educationLevel}
          >
            {educationLevelOptions.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid size={1}> </Grid>
        <Grid size={3}>
          <Typography>Département</Typography>
        </Grid>
        <Grid size={8}>
          <TextField
            error={formik.touched.deptCode && Boolean(formik.errors.deptCode)}
            fullWidth
            helperText={formik.touched.deptCode && formik.errors.deptCode}
            label="Code département"
            name="deptCode"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            select
            value={formik.values.deptCode}
          >
            {departmentOptions.map((option) => (
              <MenuItem key={option.code} value={option.code}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </>
  );
};

const currentYear = new Date().getFullYear();
const minYearOfBirth = currentYear - 18; // Calculate the minimum year of birth to be at least 18 years before now

PatientCompleteWizardStep1.label = 'Informations générales';
PatientCompleteWizardStep1.initialValues = {
  yearOfBirth: 0,
  sex: '',
  height: 0,
  weight: 0,
  maritalStatus: '',
  educationLevel: '',
  professionalStatus: '',
  deptCode: '',
};

PatientCompleteWizardStep1.validationSchema = yup.object().shape({
  yearOfBirth: yup
    .number()
    .required("L'année de naissance est requise")
    .min(1900, "L'année de naissance doit être postérieure à 1900")
    .max(minYearOfBirth, `L'année de naissance ne peut être postérieure à ${minYearOfBirth.toString()}`),
  sex: yup.string().oneOf(sexOptions, 'Sélectionner une option valide').required('Le sexe est requis'),
  height: yup
    .number()
    .required('La taille est requise')
    .min(100, 'Valeur invalide')
    .max(300, 'Valeur invalide')
    .integer('La taille doit être un nombre entier'),
  weight: yup.number().required('Le poids est requis').min(10, 'Valeur invalide').max(300, 'Valeur invalide').integer('Le poids doit être un nombre entier'),
  maritalStatus: yup.string().oneOf(maritalStatusOptions, 'Sélectionner un statut marital valide').required('Le statut marital est requis'),
  professionalStatus: yup
    .string()
    .oneOf(professionalStatusOptions, 'Sélectionner un statut professionnel valide')
    .required('Le statut professionnel est requis'),
  educationLevel: yup.string().oneOf(educationLevelOptions, "Sélectionner un niveau d'éducation valide").required("Le niveau d'éducation est requis"),
  deptCode: yup
    .string()
    .oneOf(
      departmentOptions.map((option) => option.code),
      'Sélectionner un code département valide',
    )
    .nullable(),
});

export default PatientCompleteWizardStep1;
